module.exports = __webpack_public_path__ + "img/icon_tgbz.869dda7c.png";